import { render } from "./JoinPractice.vue?vue&type=template&id=283ec7d6&ts=true"
import script from "./JoinPractice.vue?vue&type=script&lang=ts"
export * from "./JoinPractice.vue?vue&type=script&lang=ts"

import "./JoinPractice.vue?vue&type=style&index=0&id=283ec7d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__